import React from "react";
import styles from "../styles/styles";
import { getCategoryColor } from "../util/categoryColor";
export default function TractionMatrix({
    cars = [],
    categoryLabel = "Tração e Alimentação",
    dataByCar = {}
}) {
    return (
        <div style={styles.tractionWrapper}>
            <table style={styles.pantographTable}>

                <thead>
                    <tr>
                        <th style={{ width: "40px" }}></th>
                        <th style={{ width: "180px" }}></th>


                    </tr>
                </thead>

                <tbody>
                    <tr>

                        <td style={styles.tractionVertical}>
                            {categoryLabel}
                        </td>

                        <td style={styles.tractionLabel}></td>

                        {cars.map(car => (
                            <td key={car} style={styles.tractionCell}>
                                <div style={styles.tractionStack}>

                                    {(dataByCar[car] || []).map((item, i) => {

                                        const isObject =
                                            typeof item === "object";

                                        const label =
                                            isObject
                                                ? item.label
                                                : item;

                                        const active =
                                            isObject
                                                ? item.active
                                                : false;

                                        return (

                                            <div
                                                key={i}
                                                style={{
                                                    ...styles.tractionBox,

                                                    background:
                                                        item.active
                                                            ? (
                                                                getCategoryColor(
                                                                    item.category
                                                                ) || "#ef4444"
                                                            )
                                                            : "#FFFF",

                                                    color:
                                                        item.active
                                                            ? "#fff"
                                                            : "#000"
                                                }}
                                            >
                                                {label}
                                            </div>

                                        );
                                    })}
                                </div>
                            </td>
                        ))}

                    </tr>
                </tbody>

            </table>
        </div>
    );
}